import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetCampaigns = async (
  pageNumber,
  filters,
  setLoading,
  institutionId,
) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.get(`${apiConfig.baseURL}/campaigns`, {
      headers: apiConfig.headers,
      params: {
        page: pageNumber,
        institutionId: institutionId,
        totalPerPage: 10,
        ...filters,
      },
    });
    return result;
  } catch (error) {
    console.error("Error fetching campaigns:", error);
    return error;
  }
};

export const APICreateCampaign = async (
  campaignData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const formattedData = {
      ...campaignData,
      institutionId: institutionId,
    };

    const result = await axios.post(
      `${apiConfig.baseURL}/campaign`,
      formattedData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error creating campaign:", error);
    return error;
  }
};

export const APIUpdateCampaign = async (
  campaignData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const { _id, ...formattedData } = campaignData;
  const apiConfig = getApiConfig();

  try {
    const result = await axios.patch(
      `${apiConfig.baseURL}/campaign/${_id}`,
      formattedData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error updating campaign:", error);
    return error;
  }
};

export const APIDeleteCampaign = async (
  campaignId,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.delete(
      `${apiConfig.baseURL}/campaign/${campaignId}`,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error deleting campaign:", error);
    return error;
  }
};

export const APIRunCampaign = async (
  campaignId,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  const campaignData = {
    campaignId,
    institutionId,
  };

  try {
    const result = await axios.post(
      `${apiConfig.baseURL}/campaign/publish`,
      campaignData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error running campaign:", error);
    return error;
  }
};
